<script setup>
// The page dawns: every section is one step lighter than the one before it. It
// opens at night, with the photo as the only source of light, and ends in
// linen. The bands between sections are that change of tone turned into a
// gradient; the tall one is tobacco to sand, where the light comes in.
import SiteHeader from '@/components/SiteHeader.vue'
import HeroSection from '@/components/HeroSection.vue'
import ProductsSection from '@/components/ProductsSection.vue'
import FabricsSection from '@/components/FabricsSection.vue'
import ServicesSection from '@/components/ServicesSection.vue'
import ProcessSection from '@/components/ProcessSection.vue'
import MeasuringSection from '@/components/MeasuringSection.vue'
import QuoteSection from '@/components/QuoteSection.vue'
import ClosingCta from '@/components/ClosingCta.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import WhatsappBubble from '@/components/WhatsappBubble.vue'

defineProps({
  phone: { type: String, required: true }
})
</script>

<template>
  <div class="bg-night">
    <SiteHeader :phone="phone" />

    <main>
      <HeroSection :phone="phone" />

      <div class="h-12 bg-linear-to-b from-night to-cocoa" aria-hidden="true"></div>
      <ProductsSection :phone="phone" />

      <div class="h-12 bg-linear-to-b from-cocoa to-tobacco" aria-hidden="true"></div>
      <FabricsSection :phone="phone" />

      <div class="h-12 bg-linear-to-b from-tobacco to-suede" aria-hidden="true"></div>
      <ServicesSection :phone="phone" />

      <!-- This is where the light comes in. -->
      <div class="h-32 bg-linear-to-b from-suede to-sand" aria-hidden="true"></div>
      <ProcessSection :phone="phone" />

      <div class="h-12 bg-linear-to-b from-sand to-linen" aria-hidden="true"></div>
      <MeasuringSection :phone="phone" />
      <QuoteSection :phone="phone" />
      <ClosingCta :phone="phone" />
    </main>

    <SiteFooter :phone="phone" />
    <WhatsappBubble :phone="phone" />
  </div>
</template>
